/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssignmentRule } from './AssignmentRule';
import {
    AssignmentRuleFromJSON,
    AssignmentRuleFromJSONTyped,
    AssignmentRuleToJSON,
} from './AssignmentRule';

/**
 * 
 * @export
 * @interface ListAssignmentRules200Response
 */
export interface ListAssignmentRules200Response {
    /**
     * 
     * @type {Array<AssignmentRule>}
     * @memberof ListAssignmentRules200Response
     */
    data: Array<AssignmentRule>;
}

/**
 * Check if a given object implements the ListAssignmentRules200Response interface.
 */
export function instanceOfListAssignmentRules200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListAssignmentRules200ResponseFromJSON(json: any): ListAssignmentRules200Response {
    return ListAssignmentRules200ResponseFromJSONTyped(json, false);
}

export function ListAssignmentRules200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssignmentRules200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssignmentRuleFromJSON)),
    };
}

export function ListAssignmentRules200ResponseToJSON(value?: ListAssignmentRules200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(AssignmentRuleToJSON)),
    };
}

